import React from 'react';
import styled from 'styled-components';
import { FaHeart, FaArrowRight } from 'react-icons/fa';
import mach1 from "../images/mach (1).jpg";
import mach2 from "../images/mach (2).jpg";
import mach3 from "../images/mach (3).jpg";
import mach4 from "../images/mach (4).jpg";

// Styled components
const Container = styled.div`
  display: grid;
  grid-template-columns: 3fr 2fr;
  gap: 1rem;
  background-color: #f8f8f4;
  padding: 2rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const LeftColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const RightColumn = styled.div`
  display: grid;
  grid-template-rows: auto auto;
  gap: 1rem;

  @media (max-width: 768px) {
    grid-template-rows: 1fr 1fr;
  }
`;

const ImageContainer = styled.div`
  position: relative;
  overflow: hidden;
`;

const Image = styled.img`
  width: 100%;
  height: auto;
  display: block;
`;

const IconButton = styled.button`
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: white;
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  cursor: pointer;
`;

const TextContainer = styled.div`
  padding: 1rem 0;
`;

const Title = styled.h3`
  font-size: 1.2rem;
  font-weight: bold;
  color: #333;
`;

const Description = styled.p`
  font-size: 1rem;
  color: #666;
`;

const ArrowButton = styled.button`
  background: none;
  border: none;
  color: #333;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1rem;
  font-weight: bold;
  margin-top: 0.5rem;
`;

const items = [
  {
    id: 1,
    title: 'High Precision and Accuracy:',
    description: 'Advanced cutting technology ensures precise dimensions and high-quality edges.Reduces material waste by optimizing cut accuracy.',
    image: mach1,
  },
  {
    id: 2,
    title: 'Computer Numerical Control (CNC):',
    description: 'Integrated CNC technology for automated and programmable cutting patterns.Offers pre-programmed design options and custom shape capabilities, enhancing versatility.',
    image: mach2,
  },
  {
    id: 3,
    title: 'Efficient Cooling System:',
    description: "Built-in water cooling system to prevent overheating of the cutting tools.Ensures prolonged tool life and maintains cut quality, especially important for hard materials like marble.",
    image: mach3,
  },
  {
    id: 4,
    title: 'Heavy-Duty Construction:',
    description: 'Robust frame to support large marble slabs and withstand continuous heavy-duty use.Made from durable materials to ensure stability during high-speed operations.',
    image: mach4,
  },
];

const PageLayout = () => {
  return (
    <Container>
      <LeftColumn>
        <div>
          <ImageContainer>
            <Image src={items[0].image} alt={items[0].title} />
          </ImageContainer>
          <TextContainer>
            <Title>{items[0].title}</Title>
            <Description>{items[0].description}</Description>
          </TextContainer>
        </div>
        <div>
          <ImageContainer>
            <Image src={items[1].image} alt={items[1].title} />
          </ImageContainer>
          <TextContainer>
            <Title>{items[1].title}</Title>
            <Description>{items[1].description}</Description>
          </TextContainer>
        </div>
      </LeftColumn>
      <RightColumn>
        <div>
          <ImageContainer>
            <Image src={items[2].image} alt={items[2].title} />
          </ImageContainer>
          <TextContainer>
            <Title>{items[2].title}</Title>
            <Description>{items[2].description}</Description>
          </TextContainer>
        </div>
        <div>
          <ImageContainer>
            <Image src={items[3].image} alt={items[3].title} />
          </ImageContainer>
          <TextContainer>
            <Title>{items[3].title}</Title>
            <Description>{items[3].description}</Description>
          </TextContainer>
        </div>
      </RightColumn>
    </Container>
  );
};

export default PageLayout;
